var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12 " }, [
    _c("div", { staticClass: "promotionCard" }, [
      _c(
        "div",
        {
          staticClass: "row",
          staticStyle: {
            "align-items": "center",
            "justify-content": "center",
            gap: "1rem"
          }
        },
        [
          _c("div", { staticClass: "col-12 col-sm-3 " }, [
            _vm.item.product.catalogImage
              ? _c("img", {
                  staticClass: "lazyload img-fluid",
                  attrs: {
                    "data-src": _vm.item.product.catalogImage.path,
                    alt: _vm.item.product.title
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "product-description row col-12 col-sm-9",
              staticStyle: { gap: "1rem", cursor: "pointer" },
              on: {
                click: function($event) {
                  _vm.navigateToProduct(_vm.item)
                }
              }
            },
            [
              _c("div", { staticClass: "col-12 col-sm-8" }, [
                _c("div", [
                  _vm.item.product.isNewFormula
                    ? _c("span", { staticClass: "badge badge-primary" }, [
                        _vm._v("Nouvelle formule")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.product.isNew
                    ? _c("span", { staticClass: "badge badge-primary" }, [
                        _vm._v("Nouveauté")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.product.bestSales
                    ? _c("span", { staticClass: "badge badge-primary" }, [
                        _vm._v("Meilleures ventes")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.product.provenSatisfaction
                    ? _c("span", { staticClass: "badge badge-primary" }, [
                        _vm._v("Satisfaction prouvée")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.product.provenEffectiveness
                    ? _c("span", { staticClass: "badge badge-primary" }, [
                        _vm._v("Efficacité prouvée")
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("strong", [
                    _vm.item.name
                      ? _c("span", [_vm._v(_vm._s(_vm.item.name) + " -")])
                      : _vm._e(),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.item.product.title) +
                        "\n              "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n              Réf. " +
                      _vm._s(_vm.item.id) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "prix" }, [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("moneyFormat")(
                          _vm.item.discountedPrice > 0
                            ? _vm.item.discountedPrice
                            : _vm.item.price
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.item.discountedPrice > 0
                    ? _c("del", [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm._f("moneyFormat")(_vm.item.price)) +
                            "\n              "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-sm-4" }, [
                _c("div", {}, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          _vm.submit()
                        }
                      }
                    },
                    [_vm._v("Ajouter au panier")]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25447b26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25447b26","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/CartRecommendation.vue
// module id = 540
// module chunks = 1